// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoanProfileContent_wrapper__F2COT","content":"LoanProfileContent_content__2BEv3"};